import { Component, OnInit, ElementRef, EventEmitter, Output, Input, SimpleChanges } from '@angular/core';

import { IUser } from 'src/app/user/models/user.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css']
})
export class UserInfoComponent implements OnInit {

  @Input()
  user: IUser;

  @Input()
  selectedCompany: number;

  @Input()
  loginCompanies = [];

  @Output()
  logout = new EventEmitter();

  @Output()
  selectCompany = new EventEmitter();

  hasMoreCompanies: boolean = false;

  showDropdownMenu = false;

  constructor(
    private eref: ElementRef,
    private router: Router
  )
  {
    document.addEventListener('click', this.offClickHandler.bind(this));
  }

  ngOnInit() {
    if (this.loginCompanies.length > 1) {
      this.hasMoreCompanies = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.loginCompanies.length > 1) {
      this.hasMoreCompanies = true;
    }
  }

  offClickHandler(event) {
    const isInDropdown = this.eref.nativeElement
      .querySelector('#user-info-dropdown')
      .contains(event.target);

    if (this.showDropdownMenu && !isInDropdown) {
      this.showDropdownMenu = false;
    }
  }

  toggleMenu() {
    this.showDropdownMenu = !this.showDropdownMenu;
  }

  onLogout() {
    this.logout.next();
  }

  selectChange(value) {
    console.log(value);
    this.selectCompany.next(value);
  }

  showProfile() {
    this.router.navigate([{ outlets: { modal: ['user-detail', this.user.id] } }]);
  }
}
